(function () {
  var PRODUCT_FORM_SELECTOR = 'product-form';
  var FORM_SELECTOR = 'product-form form[data-type="add-to-cart-form"]';
  var QTY_SELECTOR_CLASS = 'atc-feedback-qty';
  var HIDDEN_CLASS = 'atc-feedback-hidden';
  var PENDING_CLASS = 'atc-feedback-pending';
  var TOAST_VISIBLE_CLASS = 'is-visible';
  var CART_ENDPOINT = '/cart.js';
  var UPDATE_ENDPOINT = '/cart/update.js';
  var DRAWER_SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  var FLUSH_DELAY = 350;
  var THEME_QTY_FLUSH_DELAY = 450;

  var latestCart = null;
  var cartRequestPromise = null;
  var toast = null;
  var toastTimer = null;
  var cartUpdateUnsubscribe = null;
  var reconcileTimer = null;
  var fallbackReconcileTimer = null;

  function getCartUrl(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return root.replace(/\/$/, '') + path;
  }

  function getProductForm(node) {
    return node && node.closest ? node.closest(PRODUCT_FORM_SELECTOR) : null;
  }

  function getSubmitButton(productForm) {
    return productForm.querySelector('[type="submit"][name="add"]') || productForm.querySelector('.product-form__submit');
  }

  function getVariantInput(productForm) {
    return productForm.querySelector('input[name="id"]');
  }

  function getFormQuantity(productForm) {
    var input = productForm.querySelector('input[name="quantity"]');
    var quantity = input ? Number(input.value) : 1;
    return quantity > 0 ? quantity : 1;
  }

  function shouldUseQuantitySelector() {
    return true;
  }

  function ensureToast() {
    if (toast) return toast;

    toast = document.createElement('div');
    toast.className = 'atc-feedback-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.textContent = '✅ Item added to cart';
    document.body.appendChild(toast);
    return toast;
  }

  function showToast() {
    var element = ensureToast();
    window.clearTimeout(toastTimer);
    element.classList.add(TOAST_VISIBLE_CLASS);
    toastTimer = window.setTimeout(function () {
      element.classList.remove(TOAST_VISIBLE_CLASS);
    }, 3000);
  }

  function setLatestCart(cart) {
    if (cart && Array.isArray(cart.items)) {
      latestCart = cart;
    }
  }

  function fetchCart() {
    if (cartRequestPromise) {
      return cartRequestPromise;
    }

    cartRequestPromise = fetch(getCartUrl(CART_ENDPOINT), {
      headers: {
        Accept: 'application/json',
      },
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to load cart');
        return response.json();
      })
      .then(function (cart) {
        setLatestCart(cart);
        return cart;
      })
      .finally(function () {
        cartRequestPromise = null;
      });

    return cartRequestPromise;
  }

  function findMatchingItems(cart, variantId) {
    if (!cart || !Array.isArray(cart.items)) return [];

    return cart.items.filter(function (item) {
      return String(item.variant_id) === String(variantId);
    });
  }

  function getCartQuantity(cart, variantId) {
    return findMatchingItems(cart, variantId).reduce(function (total, item) {
      return total + (Number(item.quantity) || 0);
    }, 0);
  }

  function buildQuantitySelector() {
    var selector = document.createElement('div');
    selector.className = QTY_SELECTOR_CLASS + ' quantity main-quantity';
    selector.setAttribute('role', 'group');
    selector.setAttribute('aria-label', 'Quantity selector');
    selector.innerHTML =
      '<button class="quantity__button no-js-hidden" name="minus" type="button" data-action="decrease" aria-label="Decrease quantity"><span aria-hidden="true">-</span></button>' +
      '<span class="quantity__input atc-feedback-qty__count" data-role="count" aria-live="polite" aria-atomic="true">1</span>' +
      '<button class="quantity__button no-js-hidden" name="plus" type="button" data-action="increase" aria-label="Increase quantity"><span aria-hidden="true">+</span></button>';

    return selector;
  }

  function getSelectorCountElement(selector) {
    return selector ? selector.querySelector('[data-role="count"]') : null;
  }

  function getSelectorQuantity(selector) {
    var countElement = getSelectorCountElement(selector);
    return countElement ? Number(countElement.textContent || '0') || 0 : 0;
  }

  function setSelectorQuantity(selector, quantity) {
    var countElement = getSelectorCountElement(selector);
    if (countElement) {
      countElement.textContent = String(quantity);
    }
  }

  function selectorHasPendingFlush(selector) {
    return Boolean(selector && (selector._flushTimer || selector._pendingTarget != null));
  }

  function getSwapHeight(submitButton, selector) {
    var buttonHeight = submitButton ? Math.round(submitButton.getBoundingClientRect().height) : 0;
    if (buttonHeight > 0) return buttonHeight;

    var selectorHeight = selector ? Math.round(selector.getBoundingClientRect().height) : 0;
    return selectorHeight > 0 ? selectorHeight : 0;
  }

  function ensureControlHeight(productForm, submitButton, selector) {
    var cachedHeight = Number(productForm.dataset.atcFeedbackHeight || '0') || 0;
    var controlHeight = cachedHeight || getSwapHeight(submitButton, selector);

    if (controlHeight > 0) {
      productForm.dataset.atcFeedbackHeight = String(controlHeight);
      productForm.style.setProperty('--atc-feedback-control-height', controlHeight + 'px');
    }
  }

  function removeQuantitySelector(productForm) {
    var submitButton = getSubmitButton(productForm);
    var selector = productForm.querySelector('.' + QTY_SELECTOR_CLASS);

    if (selector) {
      if (selectorHasPendingFlush(selector)) return;
      selector.remove();
    }
    if (submitButton) submitButton.classList.remove(HIDDEN_CLASS);
    productForm.classList.remove(PENDING_CLASS);
  }

  function showQuantitySelector(productForm, quantity, matchingItems) {
    var submitButton = getSubmitButton(productForm);
    var variantInput = getVariantInput(productForm);
    if (!submitButton || !variantInput || !variantInput.value) return;

    var selector = productForm.querySelector('.' + QTY_SELECTOR_CLASS);
    ensureControlHeight(productForm, submitButton, selector);

    if (!selector) {
      selector = buildQuantitySelector();
      submitButton.insertAdjacentElement('afterend', selector);
    }

    if (productForm.style.getPropertyValue('--atc-feedback-control-height')) {
      selector.style.setProperty('--atc-feedback-height', productForm.style.getPropertyValue('--atc-feedback-control-height'));
    }

    submitButton.classList.add(HIDDEN_CLASS);
    productForm.classList.remove(PENDING_CLASS);
    selector.dataset.variantId = String(variantInput.value);

    if (matchingItems) {
      selector.dataset.optimistic = 'false';
    } else {
      selector.dataset.optimistic = 'true';
    }

    // Never clobber the count while the user is mid-tap on +/-.
    if (!selectorHasPendingFlush(selector)) {
      setSelectorQuantity(selector, quantity);
    }
  }

  function renderProductForm(productForm, cart) {
    if (!productForm || !productForm.isConnected) return;

    var submitButton = getSubmitButton(productForm);
    var variantInput = getVariantInput(productForm);

    if (!submitButton || !variantInput || !variantInput.value) return;

    if (!shouldUseQuantitySelector(productForm)) {
      removeQuantitySelector(productForm);
      return;
    }

    var totalQuantity = getCartQuantity(cart, variantInput.value);

    if (totalQuantity < 1) {
      removeQuantitySelector(productForm);
      return;
    }

    showQuantitySelector(productForm, totalQuantity, true);
  }

  function renderAllProductForms(cart) {
    setLatestCart(cart);
    document.querySelectorAll(PRODUCT_FORM_SELECTOR).forEach(function (productForm) {
      renderProductForm(productForm, cart);
    });
  }

  function reconcileFromServer() {
    return fetchCart().then(function (cart) {
      renderAllProductForms(cart);
      return cart;
    });
  }

  function scheduleReconcile(delay) {
    if (delay === void 0) delay = 80;

    window.clearTimeout(reconcileTimer);
    reconcileTimer = window.setTimeout(function () {
      reconcileFromServer().catch(function (error) {
        console.error(error);
      });
    }, delay);
  }

  function renderDrawerFromSections(parsedState) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') return;
    if (!parsedState || !parsedState.sections) return;

    cartDrawer.renderContents(parsedState, true);
  }

  // Build a /cart/update.js payload keyed by line-item key that brings the
  // total quantity of a variant (possibly split across lines) to `target`.
  function buildQuantityUpdates(matchingItems, target) {
    var serverTotal = matchingItems.reduce(function (total, item) {
      return total + (Number(item.quantity) || 0);
    }, 0);

    var updates = {};

    if (target >= serverTotal) {
      var first = matchingItems[0];
      updates[first.key] = (Number(first.quantity) || 0) + (target - serverTotal);
      return updates;
    }

    var toRemove = serverTotal - target;
    for (var i = matchingItems.length - 1; i >= 0 && toRemove > 0; i--) {
      var quantity = Number(matchingItems[i].quantity) || 0;
      var reduction = Math.min(quantity, toRemove);
      updates[matchingItems[i].key] = quantity - reduction;
      toRemove -= reduction;
    }

    return updates;
  }

  function flushSelectorQuantity(selector) {
    selector._flushTimer = null;
    if (!selector.isConnected) {
      selector._pendingTarget = null;
      return;
    }

    // Serialize: line keys change between mutations (promo apps re-split
    // lines), so never compute updates while a request is still in flight —
    // its response refreshes the cart and re-flushes if the target moved.
    if (selector._inFlight) return;

    var variantId = selector.dataset.variantId;
    var target = selector._pendingTarget != null ? selector._pendingTarget : getSelectorQuantity(selector);
    if (!variantId) {
      selector._pendingTarget = null;
      return;
    }

    var matchingItems = findMatchingItems(latestCart, variantId);

    if (!matchingItems.length) {
      // The optimistic add hasn't been confirmed yet, so there are no line
      // item keys to update. Wait for the cart to catch up, bounded.
      // _pendingTarget stays set the whole time so renders can't clobber it.
      var attempts = (selector._flushAttempts || 0) + 1;
      selector._flushAttempts = attempts;

      if (target < 1 || attempts > 8) {
        selector._flushAttempts = 0;
        selector._pendingTarget = null;
        reconcileFromServer().catch(function (error) {
          console.error(error);
        });
        return;
      }

      fetchCart()
        .catch(function () {
          return null;
        })
        .then(function () {
          if (selector._flushTimer || !selector.isConnected) return;
          selector._flushTimer = window.setTimeout(function () {
            flushSelectorQuantity(selector);
          }, 300);
        });
      return;
    }

    selector._flushAttempts = 0;

    var serverTotal = matchingItems.reduce(function (total, item) {
      return total + (Number(item.quantity) || 0);
    }, 0);

    if (serverTotal === target) {
      if (!selector._flushTimer && selector._pendingTarget === target) {
        selector._pendingTarget = null;
      }
      return;
    }

    selector._inFlight = true;

    fetch(getCartUrl(UPDATE_ENDPOINT), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        updates: buildQuantityUpdates(matchingItems, target),
        sections: DRAWER_SECTIONS,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to update quantity');
        return response.json();
      })
      .then(function (cart) {
        if (cart.errors) throw new Error(cart.errors);
        selector._inFlight = false;
        setLatestCart(cart);

        // More taps arrived while the request was in flight — this response
        // is already stale, so don't paint it (the badge/drawer would dip to
        // the old count for a beat). Just flush again from the fresh keys.
        if (selector._flushTimer) return;
        if (selector._pendingTarget !== target) {
          flushSelectorQuantity(selector);
          return;
        }

        selector._pendingTarget = null;
        renderDrawerFromSections(cart);
        renderAllProductForms(cart);
      })
      .catch(function (error) {
        console.error(error);
        selector._inFlight = false;
        selector._pendingTarget = null;
        return reconcileFromServer();
      });
  }

  function applyBadgeDelta(delta) {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;

    var bubble = icon.querySelector('.cart-count-bubble');
    var countSpan = bubble ? bubble.querySelector('span[aria-hidden]') : null;
    var current = countSpan ? Number(countSpan.textContent) || 0 : 0;
    var next = Math.max(0, current + delta);

    if (next === 0) {
      if (bubble) bubble.remove();
      return;
    }

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      icon.appendChild(bubble);
      countSpan = bubble.querySelector('span[aria-hidden]');
    }

    if (countSpan) countSpan.textContent = next < 100 ? String(next) : '';
    var srSpan = bubble.querySelector('.visually-hidden');
    if (srSpan) srSpan.textContent = next + ' items';
  }

  // Lets listeners (e.g. the free-item progress bar) move in lockstep with
  // the optimistic counters instead of waiting for the server round trip.
  // Also bumps the header cart badge so every surface reacts on tap.
  function emitCartDelta(productId, delta) {
    if (!delta) return;
    applyBadgeDelta(delta);
    document.dispatchEvent(
      new CustomEvent('sg:cart-delta', {
        detail: { productId: productId ? Number(productId) : null, delta: delta },
      })
    );
  }

  function getProductIdForVariant(variantId) {
    var items = latestCart && latestCart.items ? latestCart.items : [];
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].variant_id) === String(variantId)) return items[i].product_id;
    }
    return null;
  }

  function updateQuantity(selector, delta) {
    if (!selector) return;

    var base = selector._pendingTarget != null ? selector._pendingTarget : getSelectorQuantity(selector);
    var nextQuantity = Math.max(0, base + delta);
    selector._pendingTarget = nextQuantity;
    setSelectorQuantity(selector, nextQuantity);

    var productForm = getProductForm(selector);
    emitCartDelta(productForm ? productForm.dataset.productId : null, nextQuantity - base);

    window.clearTimeout(selector._flushTimer);
    selector._flushTimer = window.setTimeout(function () {
      flushSelectorQuantity(selector);
    }, FLUSH_DELAY);
  }

  function handleQuantityClick(event) {
    var button = event.target.closest ? event.target.closest('[data-action]') : null;
    if (!button) return;

    var selector = button.closest('.' + QTY_SELECTOR_CLASS);
    if (!selector) return;

    event.preventDefault();
    updateQuantity(selector, button.dataset.action === 'increase' ? 1 : -1);
  }

  // Theme quantity steppers in the cart drawer / cart page dispatch a change
  // event per click, costing one POST + full re-render each. Intercept the
  // clicks, step the input instantly, and dispatch one change per tap burst.
  function handleThemeQuantityClick(event) {
    var button = event.target.closest ? event.target.closest('quantity-input .quantity__button') : null;
    if (!button) return;
    if (!button.closest('cart-items, cart-drawer-items, cart-drawer')) return;

    var quantityInput = button.closest('quantity-input');
    var input = quantityInput ? quantityInput.querySelector('.quantity__input') : null;
    if (!input) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var previousValue = Number(input.value) || 0;
    if (button.name === 'plus') {
      input.stepUp();
    } else {
      input.stepDown();
    }
    emitCartDelta(getProductIdForVariant(input.dataset.quantityVariantId), (Number(input.value) || 0) - previousValue);

    window.clearTimeout(input._atcFlushTimer);
    input._atcFlushTimer = window.setTimeout(function () {
      var liveInput = input.isConnected ? input : document.getElementById(input.id);
      if (!liveInput) return;
      if (liveInput !== input) liveInput.value = input.value;
      liveInput.dispatchEvent(new Event('change', { bubbles: true }));
    }, THEME_QTY_FLUSH_DELAY);
  }

  function applyOptimisticAdd(productForm) {
    var variantInput = productForm ? getVariantInput(productForm) : null;
    if (!productForm || !variantInput || !variantInput.value || !shouldUseQuantitySelector(productForm)) return;

    var selector = productForm.querySelector('.' + QTY_SELECTOR_CLASS);
    var currentQuantity = selector ? getSelectorQuantity(selector) : getCartQuantity(latestCart, variantInput.value);
    var optimisticQuantity = currentQuantity + getFormQuantity(productForm);

    showQuantitySelector(productForm, optimisticQuantity, null);
    showToast();
    emitCartDelta(productForm.dataset.productId, getFormQuantity(productForm));

    // Safety net for failed adds (sold out, errors): one reconcile fetch if
    // the theme's cartUpdate event never arrives to confirm the add.
    window.clearTimeout(fallbackReconcileTimer);
    fallbackReconcileTimer = window.setTimeout(function () {
      reconcileFromServer().catch(function (error) {
        console.error(error);
      });
    }, 4000);
  }

  function handleSubmitCapture(event) {
    var form = event.target.closest ? event.target.closest(FORM_SELECTOR) : null;
    if (!form) return;

    var productForm = getProductForm(form);
    if (productForm && productForm.dataset.atcFeedbackHandled === 'true') {
      delete productForm.dataset.atcFeedbackHandled;
      return;
    }

    applyOptimisticAdd(productForm);
  }

  function handleAddButtonClick(event) {
    var button = event.target.closest ? event.target.closest('[type="submit"][name="add"], .product-form__submit') : null;
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    var form = button.closest ? button.closest(FORM_SELECTOR) : null;
    if (!form) return;

    var productForm = getProductForm(form);
    if (productForm) {
      productForm.dataset.atcFeedbackHandled = 'true';
      window.setTimeout(function () {
        delete productForm.dataset.atcFeedbackHandled;
      }, 0);
    }

    applyOptimisticAdd(productForm);
  }

  function subscribeToCartUpdates() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) {
      window.setTimeout(subscribeToCartUpdates, 100);
      return;
    }

    if (cartUpdateUnsubscribe) return;

    cartUpdateUnsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      window.clearTimeout(fallbackReconcileTimer);
      scheduleReconcile(80);
    });
  }

  // Liquid stamps the variant's cart quantity onto each product form so the
  // stepper can render on first paint, before any cart fetch returns.
  function renderInitialSteppers() {
    document.querySelectorAll(PRODUCT_FORM_SELECTOR + '[data-initial-cart-qty]').forEach(function (productForm) {
      var quantity = Number(productForm.dataset.initialCartQty) || 0;
      if (quantity > 0 && shouldUseQuantitySelector(productForm)) {
        showQuantitySelector(productForm, quantity, true);
      }
    });
  }

  function init() {
    renderInitialSteppers();
    document.addEventListener('click', handleAddButtonClick, true);
    document.addEventListener('submit', handleSubmitCapture, true);
    document.addEventListener('click', handleQuantityClick, true);
    document.addEventListener('click', handleThemeQuantityClick, true);
    document.addEventListener('cartQuantityUpdated', function () {
      scheduleReconcile(80);
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        reconcileFromServer().catch(function (error) {
          console.error(error);
        });
      }
    });

    subscribeToCartUpdates();
    reconcileFromServer().catch(function (error) {
      console.error(error);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
